
import { TracerStudy } from "@/store/tracerstudy/types";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action, State } from "vuex-class";

@Component
export default class ModalConfirmRect extends Vue {
  /* VUEX */

  // ACTION
  @Action('actionRejectCandidate', { namespace: 'candidate' })
  private actionRejectCandidate: any;
  // STATE

  /* PROP */

  @Prop({ default: false })
  private isShow: boolean;
  @Prop({ default: false })
  private candidate: any;

  /* INITIALIZATION */

  constructor() {
    super();
  }

  /* METHOD */

  private clickSubmit() {
    this.actionRejectCandidate({
      id: this.candidate.id,
      listener: () => {
        this.$emit("onConfirmed", this.candidate);
        this.$emit("update:isShow", false);
      }
    })
  }

  private clickNo() {
    this.$emit("update:isShow", false);
  }
}
